// Sort function
export const sortItems = (items, config) => {
    if (!config.key) return items;
        const sorted = [...items].sort((a, b) => {
          const aVal = a[config.key];
          const bVal = b[config.key];
          return typeof aVal === 'string'
            ? config.direction === 'asc'
              ? aVal.localeCompare(bVal)
              : bVal.localeCompare(aVal)
            : config.direction === 'asc'
            ? aVal - bVal
            : bVal - aVal;
        });
    return sorted;
};

export const sortAlertItems = (items, config) => {
  if (!config.key) return items;
  
  const sorted = [...items].sort((a, b) => {
    let aVal = a[config.key];
    let bVal = b[config.key];
    
    // Handle different data types based on the field
    switch (config.key) {
      case 'sensor':
      case 'source':
        // Alphabetic sorting
        aVal = String(aVal || '').toLowerCase();
        bVal = String(bVal || '').toLowerCase();
        return config.direction === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      
      case 'events':
      case 'id':
        // Numeric sorting
        aVal = Number(aVal) || 0;
        bVal = Number(bVal) || 0;
        return config.direction === 'asc' ? aVal - bVal : bVal - aVal;
      
      case 'severity':
        // Custom severity ordering: high > medium > low
        const severityOrder = { 'high': 3, 'medium': 2, 'low': 1 };
        aVal = severityOrder[String(aVal).toLowerCase()] || 0;
        bVal = severityOrder[String(bVal).toLowerCase()] || 0;
        return config.direction === 'asc' ? aVal - bVal : bVal - aVal;
      
      case 'first_seen':
      case 'last_seen':
        // Date sorting
        aVal = new Date(aVal || 0);
        bVal = new Date(bVal || 0);
        return config.direction === 'asc' ? aVal - bVal : bVal - aVal;
      
      case 'phen_ignore':
        // Boolean sorting (true/false)
        aVal = Boolean(aVal);
        bVal = Boolean(bVal);
        if (aVal === bVal) return 0;
        return config.direction === 'asc' 
          ? (aVal ? 1 : -1)
          : (bVal ? 1 : -1);
      
      default:
        // Default string comparison
        aVal = String(aVal || '').toLowerCase();
        bVal = String(bVal || '').toLowerCase();
        return config.direction === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
    }
  });
  
  return sorted;
}

export const sortApplicationItems = (items, config) => {
  if (!config.key) return items;
  
  let key = config.key.toLowerCase();
  
  if (key === 'ip (dns)') { key = 'ip_dns'; }
  const sorted = [...items].sort((a, b) => {
    let aVal = a[key];
    let bVal = b[key];
    
    // Handle different data types based on the field
    
    switch (key) {
      case 'collector':
      case 'ip_dns':
      case 'ip (dns)':
        // Alphabetic sorting
        aVal = String(aVal || '').toLowerCase();
        bVal = String(bVal || '').toLowerCase();
        return config.direction === 'asc'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      
      case 'no':
      case 'id':
        // Numeric sorting
        aVal = Number(aVal) || 0;
        bVal = Number(bVal) || 0;
        return config.direction === 'asc' ? aVal - bVal : bVal - aVal;
      
      case 'authorized':
        // Boolean sorting (true/false)
        aVal = Boolean(aVal);
        bVal = Boolean(bVal);
        if (aVal === bVal) return 0;
        return config.direction === 'asc' 
          ? (aVal ? 1 : -1)
          : (bVal ? 1 : -1);
      
      default:
        // Default string comparison
        aVal = String(aVal || '').toLowerCase();
        bVal = String(bVal || '').toLowerCase();
        return config.direction === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
    }
  });
  
  return sorted;
};

export const sortAdminItems = (items, config) => {
  // Handle empty items case
  if(!items || items.length === 0) return [];
  
  if (!config.key) return items;
  
  let key = config.key.toLowerCase().trim();
  key = key.replace(" ", '');

  if (key === 'group') { key = 'groupname'; }
  else if (key === 'alertname') { key = 'name'; }
  else if (key === 'email') { key = 'emailaddr'; }
  
  const sorted = [...items].sort((a, b) => {
    let aVal = a[key];
    let bVal = b[key];
    
    // Handle different data types based on the field
    
    switch (key) {
      case 'cli':
      case 'disabled':
        // Boolean sorting (true/false)
        aVal = Boolean(aVal);
        bVal = Boolean(bVal);
        if (aVal === bVal) return 0;
        return config.direction === 'asc' 
          ? (aVal ? 1 : -1)
          : (bVal ? 1 : -1);
      
      default:
        // Default string comparison for 
        aVal = String(aVal || '').toLowerCase();
        bVal = String(bVal || '').toLowerCase();
        return config.direction === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
    }
  });
  
  return sorted;
};